module.exports = __webpack_public_path__ + "img/bespoke70_06.04fb2cee.jpg";